import React from 'react'
import Header from './Components/Header'
import MyComponent from './Components/MyComponent'

const Landingpageforindore = () => {
  return (
    <div className="md:flex flex-col items-center pt-2.5">
      <Header/>
      {/* <MainLayout/> */}
      <MyComponent city={'Indore'}/>
     
    </div>
  )
}

export default Landingpageforindore